import { Col, Row } from 'antd';
import styled from 'styled-components';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import {
  boxShadow,
} from 'Utils/utilsStyle';

const Wrapper = styled.div`
 box-shadow : ${boxShadow};
 background-color: transparent;
 border-radius: 12px;
 padding: 17px 24px;
 height: 100%;
 .triggers-col {
   .ant-pulse-triggers {
     display: flex;
     justify-content: space-between;
     height: 100%;
     padding-right: 50px;
     margin-top: 20px;
     .ant-col-triggers {
        flex: 0 0 50%;
        max-width: 50%;
      } 
    }
  }
`;

const PulseBoardFullSkeleton = function PulseBoardFullSkeleton() {
  return (
    <Wrapper className="pulse-wrapper">
      <div className="heading-inner-page mb-c-10">
        <SkeletonCustom height="40px" width="110px" diameter="10px" margin="0 13px 0 0" />
        <div className="tabs-wrapper">
          {[1, 2, 3].map((val) => (
            <span className="resolution-fix pulse-board-tabs">
              <SkeletonCustom
                height="55px"
                width="110px"
                diameter="10px"
                margin="0 13px 0 0"
                key={val}
              />
            </span>
          ))}
        </div>
      </div>
      <Row className="pulse-row">
        <Col span={24} className="pulse-col">
          {
            [1, 2, 3, 4, 5, 6, 7].map(
              (val) => (
                <SkeletonCustom
                  height="22px"
                  width="calc(100% - 50px)"
                  diameter="10px"
                  margin="0px"
                  key={val}
                />
              ),
            )
          }
        </Col>
        <Col span={24} className="triggers-col">
          <Row className="ant-pulse-triggers">
            {
              [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((val) => (
                <Col className="ant-col-triggers">
                  <SkeletonCustom height="25px" width="80px" diameter="10px" margin="0px" key={val} />
                </Col>
              ))
            }
          </Row>
        </Col>
      </Row>
    </Wrapper>
  );
};
export default PulseBoardFullSkeleton;
